/**
 * Canonical public URL for Earth Pulse. Used for:
 *   – Share links (so folks share earthpulse.store, not the preview host)
 *   – origin_url on payment / reading form submissions (so email links
 *     always point at production, regardless of which environment the
 *     buyer completes checkout from)
 */
export const SITE_URL = "https://earthpulse.store";

/**
 * Build a canonical share/deep-link URL for a given path.
 * @param {string} path  route (with or without leading slash)
 */
export function getShareUrl(path = "/") {
  const p = path.startsWith("/") ? path : `/${path}`;
  return `${SITE_URL}${p}`;
}
